import { render } from "./CompanyProcessUserInviteForm.vue?vue&type=template&id=18389c00"
import script from "./CompanyProcessUserInviteForm.vue?vue&type=script&lang=js"
export * from "./CompanyProcessUserInviteForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__